import { createSlice } from "@reduxjs/toolkit";
import { createConversation, getChatList } from "./_chatbotAction";


interface ManageChatbotState {
  chatList:  any[];
  loading: boolean;
  error: string | null;
}

const initialState: ManageChatbotState = {
  chatList: [],
  loading: false,
  error: null,
};


export const chatbotReducer = createSlice({
  name: "chatbot",
  initialState: initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Invite User List
      .addCase(createConversation.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createConversation.fulfilled, (state, action) => {
        state.loading = false;
        state.chatList = action.payload?.data;
      })
      .addCase(createConversation.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
  },
});


export const { clearError } = chatbotReducer.actions;
export default chatbotReducer;